import {
  FormHelperText as MuiFormHelperText,
  FormHelperTextProps as MuiFormHelperTextProps,
  styled,
} from "@mui/material";

export type FormHelperTextProps = MuiFormHelperTextProps & {
  warning?: boolean;
};

/**
 * MUI FormHelperText wrapper that filters out the `warning` prop
 * to prevent it from being passed to the DOM element.
 */
export const FormHelperText = styled(MuiFormHelperText, {
  shouldForwardProp: (prop) => prop !== "warning",
})<FormHelperTextProps>(({ theme, warning }) => ({
  ...(warning && {
    color: theme.palette.custom.textWarning,
  }),
}));
